<div class="loader-main loader-full "  *ngIf="isLoader" >
  <div class="loader-wrap">
      <span class="loader"></span>
      <!-- <img src="assets/images/logos/logo.svg" alt=""> -->
      <img style="width: 90px; max-width: none;" src="./assets/images/logos/erx-logo.svg" alt="erx logo">
  </div>
</div>
